import React, { useEffect, useRef, useState } from 'react';
import { FaRegEye, } from 'react-icons/fa';
import { InfinitySpin } from 'react-loader-spinner';
import { GrEdit } from "react-icons/gr";
import { IoMdClose } from 'react-icons/io';
import AddStock from './AddStock';
import EditStock from './EditStock';
import { useSelector } from 'react-redux';
import { api_url } from '../../../config';
import { toast } from 'react-toastify';
import StockDetail from './StockDetail';
import DeleteStock from './DeleteStock';
import { MdOutlineDeleteForever } from 'react-icons/md';
import { hasPermission } from '../../../Redux/permissionSlice';
import { selectRoles } from '../../../Redux/AuthSlice';
import api from '../../../utils/api';
import exportFromJSON from 'export-from-json';
import Table from '../../../components/dataUi/Table';
import { FaGreaterThan } from "react-icons/fa";
import Portal from '../../../utils/Portal';

const StocksInfo = () => {
    const [stocks, setStocks] = useState([]);
    const [stock, setStock] = useState([]);
    const [products, setProducts] = useState([]);
    const [error, setError] = useState([]);
    const [filteredStocks, setFilteredStocks] = useState([]);
    const [loading, setLoading] = useState(true)
    const [selectedDropdown, setSelectedDropdown] = useState(null);
    const [stockToEdit, setStockToEdit] = useState(null);
    const [stockToDelete, setStockToDelete] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const modalRef = useRef();
    const { id, token, branch_id } = useSelector((state) => state.auth)
    const [stock_view, setStock_view] = useState(false);
    const [activeTab, setActiveTab] = useState('All');
    const [filter, setFilter] = useState('');
    const [filter_status, setFilter_status] = useState('');
    const [sortby, setSortby] = useState('-created_at');
    const [search, setSearch] = useState('');
    const [hasSearched, setHasSearched] = useState(false);

    useEffect(() => {
        // Function to handle click outside of modal
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowModal(false);
                setEditModal(false)
                setDeleteModal(false)
            }
        };

        // Attach the event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        // Function to handle click outside of modal
        const handleClickOutside = (event) => {
            if (popUpRef.current && !popUpRef.current.contains(event.target)) {
                setSelectedDropdown(null);
            }
        };

        // Attach the event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const fetchStocks = async () => {
        setLoading(true);
        if (!navigator.onLine) {
            toast("You're offline");
            setLoading(false);
            return;
        }
        try {
            const response = await api.get(api_url + `/api/v1/retailer/user/${id}/branch/${branch_id}/stock`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            })
            const data = response.data.data;
            setStocks(data);
            setFilteredStocks(data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }
    const fetchProducts = async () => {
        try {
            const response = await api.get(api_url + `/api/v1/retailer/user/${id}/branch/${branch_id}/inventory/list`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            })
            const data = response.data.data
            setProducts(data)
        } catch (error) {
            setError(error?.response?.data?.error)
        }
    }

    useEffect(() => {
        fetchStocks();
        fetchProducts();
    }, [id, token, filter, filter_status, sortby]);

    const popUpRef = useRef();

    const toggleStockForm = () => {
        setShowModal(!showModal)
    };

    const handleDeleteStock = (event, stockId) => {
        if (event) {
            event.preventDefault(); // Prevent default behavior
            event.stopPropagation();
        }
        const stockToDelete = stocks.find(stock => stock.id === stockId);
        if (stockToDelete) {
            setDeleteModal(true);
            setStockToDelete(stockToDelete);
        }
    };

    const switchTab = (value) => {
        setActiveTab(value);
        setLoading(true)
        setHasSearched(false)
        switch (value) {
            case 'lowonstock':
                setFilter_status('low-on-stock')
                setFilter('stock_status')
                break;
            case 'outofstock':
                setFilter_status('out-of-stock')
                setFilter('stock_status')
                break;
            case 'expiringsoon':
                setFilter('expiry_status')
                setFilter_status('expiring')
                break;
            case 'expired':
                setFilter('expiry_status')
                setFilter_status('expired')
                break;
            default:
                setFilter_status('')
                setFilter('')
        }
    };

    const showStockDetail = (data) => {
        setStock_view(!stock_view)
        setStock(data)
    }

    useEffect(() => {
        if (stocks && Array.isArray(stocks)) {
            setFilteredStocks(stocks);
        }
    }, [stocks]);

    const selectedRoles = useSelector(selectRoles);
    const roles = Array.isArray(selectedRoles) ? selectedRoles : selectedRoles.split(',').map(role => role.trim());

    const exportFunc = () => {
        const data = stocks?.map(s => ({
            id: s.id,
            Product_name: s.inventory.name,
            Manufacturer: s.manufacturer,
            Quantity_received: s.quantity_received,
            Quantity_left: s.quantity,
            Unit_price: s.price,
            Date_received: s.date_received,
            Date_created: new Date(s?.created_at).toLocaleDateString(),
            Expiry_date: s.expiry_date
        }))
        const fileName = 'Stocks'
        const exportType = exportFromJSON.types.csv

        exportFromJSON({ data, fileName, fields: ["id", "Product_name", "Manufacturer", "Quantity_received", "Quantity_left", "Unit_price", "Date_received", "Date_created", "Expiry_date"], exportType })
    }

    // Define table headers
    const tableHeaders = [
        { key: 'batch_number', label: 'Batch No.', sortable: true },
        { key: 'product_name', label: 'Product Name', sortable: true },
        { key: 'supplier_name', label: 'Supplier Name', sortable: true, tooltipEnabled: true },
        { key: 'manufacturer', label: 'Manufacturer', sortable: true },
        { key: 'quantity_received', label: 'Quantity Received', sortable: true },
        { key: 'quantity', label: 'Quantity Remaining', sortable: true },
        { key: 'price', label: 'Unit Price', sortable: true },
        { key: 'date_received', label: 'Date Received', sortable: true },
        { key: 'created_at', label: 'Date Created', sortable: true },
        { key: 'expiry_date', label: 'Expiry Date', sortable: true },
    ];

    // Define actions for table rows
    const tableActions = [
        {
            label: 'View',
            variant: 'primary',
            icon: <FaRegEye className="text-xs" />,
            onClick: (row) => showStockDetail(row._originalData)
        },
        {
            label: 'Edit',
            variant: 'secondary',
            icon: <GrEdit className="text-xs" />,
            onClick: (row) => {
                // Set the stock to edit directly from the row data
                setStockToEdit(row._originalData);
                // Then open the modal
                setEditModal(true);
            },
            showIf: () => hasPermission(roles, ['stockWriter', 'stockAdmin'])
        },
        {
            label: 'Delete',
            variant: 'danger',
            icon: <MdOutlineDeleteForever className="text-xs" />,
            onClick: (row) => handleDeleteStock(null, row._originalData.id),
            showIf: () => hasPermission(roles, ['stockAdmin'])
        }
    ];

    // Format stock data for the Table component
    const formatStocksForTable = () => {
        return filteredStocks.map(stock => ({
            id: stock.id,
            batch_number: stock.batch_number,
            product_name: stock?.inventory?.name,
            supplier_name: stock?.contact?.name,
            manufacturer: stock.manufacturer,
            quantity_received: stock.quantity_received,
            quantity: stock.quantity,
            price: stock.price,
            date_received: new Date(stock.date_received).toLocaleDateString(),
            created_at: new Date(stock.created_at).toLocaleDateString(),
            expiry_date: new Date(stock.expiry_date).toLocaleDateString(),
            _originalData: stock
        }));
    };

    // Define status configuration for stock status styling
    const statusConfig = {
        'low-on-stock': {
            label: 'Low on Stock',
            className: 'bg-yellow-100 text-yellow-800'
        },
        'out-of-stock': {
            label: 'Out of Stock',
            className: 'bg-red-100 text-red-800'
        },
        'expiring': {
            label: 'Expiring Soon',
            className: 'bg-orange-100 text-orange-800'
        },
        'expired': {
            label: 'Expired',
            className: 'bg-red-200 text-red-900'
        }
    };

    // Define filter options for the table
    const filterOptions = [
        { label: 'Low on Stock', value: 'low-on-stock' },
        { label: 'Out of Stock', value: 'out-of-stock' },
        { label: 'Expiring Soon', value: 'expiring' },
        { label: 'Expired', value: 'expired' }
    ];

    return (
        <div className='absolute w-full h-full font-lufga'>
            {!stock_view ? (
                <div className='font-lufga'>
                    {loading && (
                        <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full bg-gradient-to-br from-opacity-40 to-opacity-60 backdrop-blur-sm">
                            <InfinitySpin color="#059212" loading={loading} size={40} />
                        </div>
                    )}
                    <div className='flex items-center justify-start w-full gap-2 px-4 mb-3 overflow-x-auto font-lufga sm:gap-4 whitespace-nowrap retail-scrollbar'>
                        <button
                            className={`text-xs cursor-pointer py-2 px-4 text-nowrap ${activeTab === 'All'
                                ? 'border-b-2 border-green-500 text-green-500'
                                : 'text-gray-500'
                                }`}
                            onClick={() => switchTab('All')}
                        >
                            All
                        </button>
                        <button
                            className={`text-xs sm:text-sm cursor-pointer py-2 px-4 ${activeTab === 'lowonstock'
                                ? 'border-b-2 border-green-500 text-green-500'
                                : 'text-gray-500'
                                }`}
                            onClick={() => switchTab('lowonstock')}
                        >
                            Low on Stock
                        </button>
                        <button
                            className={`text-xs sm:text-sm cursor-pointer py-2 px-4 ${activeTab === 'outofstock'
                                ? 'border-b-2 border-green-500 text-green-500'
                                : 'text-gray-500'
                                }`}
                            onClick={() => switchTab('outofstock')}
                        >
                            Out of Stock
                        </button>
                        <button
                            className={`text-xs sm:text-sm cursor-pointer py-2 px-4 ${activeTab === 'expiringsoon'
                                ? 'border-b-2 border-green-500 text-green-500'
                                : 'text-gray-500'
                                }`}
                            onClick={() => switchTab('expiringsoon')}
                        >
                            Expiring soon
                        </button>
                        <button
                            className={`text-xs sm:text-sm cursor-pointer py-2 px-4 ${activeTab === 'expired'
                                ? 'border-b-2 border-green-500 text-green-500'
                                : 'text-gray-500'
                                }`}
                            onClick={() => switchTab('expired')}
                        >
                            Expired
                        </button>
                    </div>
                    <div className=''>
                        {!loading && (
                            <div className='mx-6 font-lufga'>
                                <Table
                                    headers={tableHeaders}
                                    rows={formatStocksForTable()}
                                    actions={tableActions}
                                    emptyMessage={search ? `No results found for "${search}"` : "No stocks available"}
                                    headerBgColor="bg-green-200"
                                    onRowClick={(row) => showStockDetail(row._originalData)}
                                    title="Stocks"
                                    itemsPerPage={50}
                                    searchPlaceholder="Search by batch no, product, supplier..."
                                    onAdd={hasPermission(roles, ['stockWriter', 'stockAdmin']) ? toggleStockForm : undefined}
                                    addButtonText="Add Stock"
                                    addButtonClassName="bg-green-500 hover:bg-green-600 text-white"
                                    exportButtonText="Export"
                                    onExport={exportFunc}
                                    filterOptions={filterOptions}
                                    statusConfig={statusConfig}
                                    className="text-xs "
                                />
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className='relative'>
                    {/* <div>
                        <p onClick={() => { setStock_view(false) }} className='flex items-center gap-1 cursor-pointer hover:text-neutral-400'><IoArrowBackCircleOutline size={28} />Go back</p>
                    </div>
                    <div className='mx-8 my-4'>
                        <p className='text-xl font-semibold lg:text-3xl text-slate-600'>Stock Details</p>
                    </div> */}
                    <div className='mx-10 mt-4'>
                        <p className='text-xl font-semibold lg:text-3xl text-slate-600'>Stock Details</p>
                    </div>
                    <div className='flex items-center gap-2 mx-10 my-2'>
                        <p onClick={() => { setStock_view(false) }} className='flex items-center text-green-700 cursor-pointer'>Stocks</p>
                        <p className=''><FaGreaterThan size={12} /></p>
                        <p>Stock Details</p>
                    </div>
                    <div className='grid gap-8 rounded-sm shadow-md lg:grid-cols-[minmax(50px,300px)_repeat(5,1fr)] lg:gap-0 mx-8'>
                        <div className='col-span-4 lg:col-span-1 bg-neutral-100'>
                            <div className='flex flex-col gap-2 max-h-[60vh] overflow-auto'>
                                <div className='sticky top-0 p-2 z-1 bg-neutral-100 w-100'>
                                    <p className='w-full text-sm font-lufga'>Stock List</p>
                                </div>
                                {stocks.map((data) => (
                                    <div
                                        key={data.id}
                                        className={`cursor-pointer  mx-2 p-[1rem] shadow-md bg-white  hover:bg-green-200 transition-colors duration-200 ${stock.id === data.id ? 'bg-green-200' : ''}`}
                                        onClick={() => setStock(data)}
                                    >
                                        <p className='text-sm'>{data?.inventory?.name}</p>
                                        <p className='text-xs font-bold text-green-700'>{data?.manufacturer}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='col-span-4 p-2 lg:col-span-5'>
                            <p className='w-full text-sm font-lufga '>Details</p>
                            <div className='max-h-[60vh] overflow-auto'>
                                <StockDetail roles={roles} toggle={stock_view} data={stock} products={products} fetchStocks={fetchStocks} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showModal && (
                <Portal>
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
                        <div ref={modalRef} className="p-2 bg-white rounded-md shadow-lg min-h-max z-[9999]">
                            <div className="flex items-center justify-between p-4 border-b">
                                <h3 className="text-lg font-semibold text-gray-700">Add New Stock</h3>
                                <button
                                    onClick={toggleStockForm}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    <IoMdClose size={24} />
                                </button>
                            </div>
                            <AddStock
                                toggle={toggleStockForm}
                                fetchStocks={fetchStocks}
                                products={products}
                            />
                        </div>
                    </div>
                </Portal>
            )}
            {editModal && (
                <Portal>
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
                        <div ref={modalRef} className="p-2 bg-white rounded-md shadow-lg min-h-max z-[9999]">
                            <div className="flex items-center justify-between p-4 border-b">
                                <h3 className="text-lg font-semibold text-gray-700">Edit Stock</h3>
                                <button
                                    onClick={() => setEditModal(false)}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    <IoMdClose size={24} />
                                </button>
                            </div>
                            <EditStock
                                toggle={() => setEditModal(false)}
                                stock={stockToEdit}
                                fetchStocks={fetchStocks}
                                products={products}
                            />
                        </div>
                    </div>
                </Portal>
            )}
            {deleteModal && (
                <Portal>
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
                        <div ref={modalRef} className="p-2 bg-white rounded-md shadow-lg min-h-max z-[9999]">
                            <div className="flex items-center justify-between p-4 border-b">
                                <h3 className="text-lg font-semibold text-gray-700">Delete Stock</h3>
                                <button
                                    onClick={() => setDeleteModal(false)}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    <IoMdClose size={24} />
                                </button>
                            </div>
                            <DeleteStock
                                toggle={() => setDeleteModal(false)}
                                data={stockToDelete}
                                fetchStocks={fetchStocks}
                            />
                        </div>
                    </div>
                </Portal>
            )}
        </div>
    );
}

export default StocksInfo;
